/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { Card, FormControlLabel, Grid, Stack, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { checkEnableParseJSON } from 'components/helper/helper';
import { catName } from 'components/helper/helper';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { checkModule, logout, setPartners } from 'app/basicInformationSlice/basicInformationSlice';
import { setCheckModule } from 'app/basicInformationSlice/basicInformationSlice';
import counselorServices from 'services/counselorServices';
import collegeServices from 'services/collegeServices';
import RPersonalInformation, { moduleName } from 'screen/counselor/components/RPersonalInformation';
import { NoteStatus } from 'screen/counselor/counselor.types';
import { useFormik } from 'formik';
import moment from 'moment';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useWebSocket } from 'hooks/useWebSocket';
import { getUserId, removeUserId, removeAccessToken, getAccessToken } from 'utils/sessionStorage';
// import Accordion from '@mui/material/Accordion';
// import AccordionSummary from '@mui/material/AccordionSummary';
// import AccordionDetails from '@mui/material/AccordionDetails';
// import TextAreaInput from 'components/input/TextAreaInput';

// Add CSS animations
const messageStyles = `
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes slideInRight {
    from {
      opacity: 0;
      transform: translateX(20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  @keyframes slideInLeft {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  @keyframes fadeOutNew {
    0% {
      opacity: 1;
      transform: translateX(-50%) scale(1);
    }
    70% {
      opacity: 1;
      transform: translateX(-50%) scale(1);
    }
    100% {
      opacity: 0;
      transform: translateX(-50%) scale(0.8);
    }
  }
  
  .message-container {
    scroll-behavior: smooth;
  }
  
  .message-bubble {
    transition: all 0.2s ease-in-out;
  }
  
  .message-bubble:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.15) !important;
  }
  
  .new-message-label {
    animation: fadeOutNew 3s ease-in-out forwards;
  }
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.type = 'text/css';
  styleSheet.innerText = messageStyles;
  document.head.appendChild(styleSheet);
}

const tabContent: any = {
  1: 'Personal Information',
  2: 'Family',
  3: 'Education',
  4: 'Tests',
  5: 'Courses & Grades',
  6: 'Activities & Honors',
  7: 'Additional Info',
  9: 'GPA Forecaster',
};
const initValues: {
  content: string;
  status: NoteStatus;
  isStudentReviewed: boolean;
  isCounselorApproved: boolean;
} = {
  content: '',
  status: '',
  isStudentReviewed: false,
  isCounselorApproved: false,
};

const ReviewPersonal = () => {
  const dispatch:any = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();
  const [listCounselorConnection, setListCounselorConnection] = React.useState<any[]>([]);
  const [currentModuleId, setCurrentModuleId] = React.useState('1.1');

  const handleLogout = () => {  
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const getData = () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      counselorServices.getCounselors(studentId).then((res: any[]) => {
        setListCounselorConnection(res ?? []);
      }).catch((error) => {
        setListCounselorConnection([]);
      });
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getData();
    console.log('currentModuleId:', currentModuleId);
    console.log('listCounselorConnection:', listCounselorConnection);
  }, []);

  return (
    <Grid container sx={{ width: '100%' }}>
      <Grid item xs={12} md={8}>
        <RPersonalInformation setCurrentModuleId={setCurrentModuleId} />
      </Grid>
      {/* <Grid item xs={12} md={4} sx={{ marginTop: { md: '48px' } }}>
        {listCounselorConnection.length === 0 ? (
          <Typography 
            variant="body2" 
            color="textSecondary" 
            sx={{ 
              textAlign: 'center', 
              py: 3,
              fontStyle: 'italic',
              color: '#6c757d'
            }}
          >
            No counselor connections found
          </Typography>
        ) : (
          listCounselorConnection.map((item, index) => {
            return (
              <ConversationCard 
                conversationItem={item} 
                currentModuleId={currentModuleId} 
                key={index} 
              />
            );
          })
        )}
      </Grid> */}
    </Grid>
  );
};

export const ConversationCard = ({
  conversationItem,
  currentModuleId,
}: {
  conversationItem: any;
  currentModuleId: any;
}) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const personalStore = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const reduxCheckModule = useAppSelector((store) => store.basicInformation.checkModule);
  const [checkedData, setCheckedData] = React.useState(() => {
    // Use Redux store if available, otherwise fall back to default checkModule
    return reduxCheckModule || checkModule;
  });
  const [studentReviewed, setStudentReviewed] = React.useState(() => {
    // Initialize with Redux store data if available, otherwise false
    return reduxCheckModule?.[currentModuleId]?.[0] || false;
  });
  const [partnerInfo, setParnerInfo] = useState<any>(null);
  const [isTyping, setIsTyping] = useState(false);
  const [typingUser, setTypingUser] = useState<string>('');
  const [newestMessageId, setNewestMessageId] = useState<number | null>(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isReviewUpdating, setIsReviewUpdating] = useState(false);
  let token = getAccessToken();

  // Tạo conversation_id cho message (giữ nguyên)
  const conversationId = `${currentModuleId}|${conversationItem?.partner_id}|${conversationItem?.student_id}`;
  const userId = personalStore?.student_id ?? 0;
  // Tạo conversation_id cho review (room riêng)
  const counselorId = conversationItem?.partner_id || conversationItem?.counselor_id || '';
  const reviewConversationId = `${userId}|${counselorId}`;

  // Utility function to update checkModule consistently
  const updateCheckModuleState = useCallback((moduleId: string, reviewType: 'student_review' | 'counselor_review', isReviewed: boolean) => {
    const updatedCheckModule = {
      ...checkedData,
      [moduleId]: [
        reviewType === 'student_review' ? isReviewed : checkedData?.[moduleId]?.[0],
        reviewType === 'counselor_review' ? isReviewed : checkedData?.[moduleId]?.[1]
      ]
    };
    
    
    
    // Update all states consistently
    setCheckedData(updatedCheckModule);
    dispatch(setCheckModule(updatedCheckModule));
    
    return updatedCheckModule;
  }, [checkedData, dispatch]);

  // WebSocket cho message
  const {
    isConnected,
    messages: notesData,
    isLoading,
    error,
    sendMessage,
    sendTyping,
    // KHÔNG lấy sendReview ở đây nữa
  } = useWebSocket({
    conversationId,
    userId,
    userType: 'student',
    onNewMessage: (message) => {
      setNewestMessageId(message.message_id || null);
    },
    onUserTyping: (data) => {
      if (data.user_id !== userId) {
        setIsTyping(data.action === 'start');
        setTypingUser(data.user_type === 'counselor' ? 'Counselor' : 'Student');
      }
    },
    // Không xử lý review ở đây nữa
  });

  // WebSocket cho review (room riêng)
  const {
    sendReview,
  } = useWebSocket({
    conversationId: reviewConversationId,
    userId,
    userType: 'student',
    onReviewUpdate: (data) => {
      if (data.check_module) {
        setCheckedData(data.check_module);
        dispatch(setCheckModule(data.check_module));
        setStudentReviewed(data.check_module?.[currentModuleId]?.[0] || false);
      } else if (data.module_id === currentModuleId) {
        // Update checkModule state using utility function
        // const updatedCheckModule = updateCheckModuleState(
        //   data.module_id, 
        //   data.review_type, 
        //   data.is_reviewed
        // );

        // Update local state nếu là student review
        if (data.review_type === 'student_review') {
          setStudentReviewed(data.is_reviewed);
        }
      }
    },
  });

  // Background API update function
  const updateCheckModuleInAPI = async (updatedCheckModule: any) => {
    try {
      if (conversationItem?.id) {
        await counselorServices.updatePartnerById({
          id: conversationItem.id,
          notes_array: JSON.stringify({
            checkModule: updatedCheckModule,
          }),
        });
      }
    } catch (error) {
      // Don't revert state, let WebSocket be the source of truth
    }
  };

  const formik = useFormik({
    initialValues: initValues,
    onSubmit: async (values) => {
      var creatorName = catName(personalStore?.first_name, personalStore?.middle_name, personalStore?.last_name)

      // Only send message if there's content
      if (values.content) {
        try {
          // Send email notification
          if (conversationItem?.partner_info?.email) {
            const body = {
              content: values.content,
              sender: creatorName,
              email: conversationItem?.partner_info?.email,
              receiver: conversationItem?.partner_info?.first_name,
              linkPage: `${tabContent[currentModuleId.slice(0, 1)]} > ${
                moduleName[currentModuleId]
              }`,
            };
            currentModuleId.includes('8.')
              ? collegeServices?.sendMailChat(body)
              : collegeServices.sendMailUserMessage(body);
          }

          // Send message via WebSocket only
          const toId = conversationItem?.partner_info?.student_id || '';
          if (toId) {
            await sendMessage(values.content, toId, creatorName);
          }

          formik.resetForm();
          getPartnerDataById(false);
        } catch (error) {
          console.error('Failed to send message:', error);
          // Fallback to HTTP if WebSocket fails
          let couserlorId = conversationItem?.partner_info?.student_id || '';
          if (couserlorId) {
            counselorServices.sendChatNotesMessage({
              module_id: currentModuleId,
              couserlor_id: couserlorId,
              student_id: personalStore.student_id,
              creator: creatorName,
              from_id: personalStore.student_id,
              to_id: couserlorId,
              content: values.content,
              status: values.status,
            });
          }
        }
      }
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const getPartnerDataById = async (onInit: boolean) => {
    if (!conversationItem?.id) return;
    token = getAccessToken();
    if (token) {
      counselorServices.getPartnerById(conversationItem.id).then((res: any) => {
        setParnerInfo(res);
        dispatch(setPartners(res));

        const loadedCheckModule =
          checkEnableParseJSON(res?.notes_array, {
            checkModule,
            notes: [],
          })?.checkModule ?? checkModule;

        setCheckedData(loadedCheckModule);
        dispatch(setCheckModule(loadedCheckModule));
        setIsDataLoaded(true);
        if (onInit) {
          setStudentReviewed(loadedCheckModule?.[currentModuleId]?.[0]);
        }
      }).catch((error) => {
        // Set data loaded to true even on error to allow checkbox interaction
        setIsDataLoaded(true);
      });
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getPartnerDataById(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentModuleId, conversationItem.id]);

  // Sync local state with Redux store
  React.useEffect(() => {
    if (reduxCheckModule && Object.keys(reduxCheckModule).length > 0) {
      setCheckedData(reduxCheckModule);
      setIsDataLoaded(true);
    }
  }, [reduxCheckModule]);

  // Update studentReviewed when Redux store or currentModuleId changes
  React.useEffect(() => {
    if (reduxCheckModule && reduxCheckModule[currentModuleId] && !isReviewUpdating) {
      setStudentReviewed(reduxCheckModule[currentModuleId][0]);
    }
  }, [reduxCheckModule, currentModuleId, isReviewUpdating]);

  // Handle typing indicator
  const handleTyping = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    formik.handleChange(e);
    if (e.target.value.length > 0) {
      sendTyping('start');
    } else {
      sendTyping('stop');
    }
  };

  // Stop typing when user stops typing for 1 second
  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (formik.values.content.length === 0) {
        sendTyping('stop');
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [formik.values.content, sendTyping]);

  // Reset newest message ID when conversation changes
  React.useEffect(() => {
    setNewestMessageId(null);
  }, [conversationId]);

  // Scroll to top when new messages arrive
  React.useEffect(() => {
    const messageContainer = document.querySelector('.message-container');
    if (messageContainer && notesData?.length > 0) {
      // Always scroll to top to show newest messages
      messageContainer.scrollTop = 0;
    }
  }, [notesData?.length]);

  // Scroll to top when component mounts or conversation changes
  React.useEffect(() => {
    const messageContainer = document.querySelector('.message-container');
    if (messageContainer) {
      messageContainer.scrollTop = 0;
    }
  }, [conversationId]);

  // Stop typing indicator when conversation changes
  React.useEffect(() => {
    setIsTyping(false);
    setTypingUser('');
  }, [conversationId]);

  // Handle review update with immediate local state update
  const handleReviewUpdate = async (isReviewed: boolean) => {
    
    if (isReviewUpdating) {
      return; // Prevent multiple simultaneous updates
    }
    
    setIsReviewUpdating(true);
    
    // Immediately update local state for better UX
    setStudentReviewed(isReviewed);
    formik.setFieldValue(
      'content',
      isReviewed ? 'Student Marked Reviewed' : 'Student UN-checked Reviewed'
    );
    
    // Immediately update checkModule state
    const updatedCheckModule = updateCheckModuleState(
      currentModuleId, 
      'student_review', 
      isReviewed
    );
    
    try {
      // Always update API first to ensure data persistence
      await updateCheckModuleInAPI(updatedCheckModule);
      
      if (isConnected) {
        // Sử dụng sendReview từ review room
        await sendReview(currentModuleId, 'student_review', isReviewed, updatedCheckModule);
      }
    } catch (error) {
      // Revert local state on error
      setStudentReviewed(!isReviewed);
      updateCheckModuleState(currentModuleId, 'student_review', !isReviewed);
    } finally {
      setIsReviewUpdating(false);
    }
  };

  console.log('partnerInfo:', partnerInfo);
  // Force enable checkbox if data is not loaded after 3 seconds
  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (!isDataLoaded) {
        setIsDataLoaded(true);
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [isDataLoaded]);

  return (
    <Card sx={{ p: 2, m: 2, borderRadius: 2, boxShadow: 3 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
        <CheckCircleOutlineIcon color="primary" />
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Counselor Communication
        </Typography>
        {!isConnected ? (
          <Typography variant="caption" color="error" sx={{ ml: 1 }}>
            (Offline)
          </Typography>
        ) : (
          <Typography variant="caption" color="success" sx={{ ml: 1 }}>
            (Online)
          </Typography>
        )}
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ borderBottom: '1px solid #eee', lineHeight: '1.5' }}
      >
        <Typography variant="body1">Student:</Typography>
        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
          {catName(personalStore?.first_name, personalStore?.middle_name, personalStore?.last_name)}
        </Typography>
      </Stack>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: '4px', pb: '4px', borderBottom: '1px solid #eee' }}
      >
        <Typography variant="body1">Counselor:</Typography>
        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
          {catName(conversationItem.partner_info?.first_name, conversationItem.partner_info?.middle_name, conversationItem.partner_info?.last_name)}
        </Typography>
      </Stack>

      <Typography
        variant="subtitle2"
        sx={{ color: 'text.secondary', fontSize: '1rem', lineHeigh: '1.5' }}
      >
        {moduleName[currentModuleId]} Status
      </Typography>

      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <div className="row">
          <div className="col-md-12">
            {!isDataLoaded ? (
              <Typography 
                variant="body2" 
                color="textSecondary" 
                sx={{ 
                  fontStyle: 'italic',
                  color: '#6c757d',
                  fontSize: '0.875rem'
                }}
              >
                Loading status...
              </Typography>
            ) : (
              <FormControlLabel
                control={
                  <Checkbox
                    style={{ paddingTop: '4px', paddingBottom: '4px' }}
                    checked={studentReviewed}
                    disabled={isReviewUpdating}
                    onChange={(e: any) => {
                      handleReviewUpdate(e.target.checked);
                    }}
                    name="isStudentReviewed"
                  />
                }
                label="Student reviewed"
              />
            )}
          </div>
          <div className="col-md-12">
            {!isDataLoaded ? (
              <Typography 
                variant="body2" 
                color="textSecondary" 
                sx={{ 
                  fontStyle: 'italic',
                  color: '#6c757d',
                  fontSize: '0.875rem'
                }}
              >
                Loading status...
              </Typography>
            ) : (
              <FormControlLabel
                control={
                  <Checkbox
                    style={{ paddingTop: '0', paddingBottom: '0' }}
                    disabled
                    checked={checkedData?.[currentModuleId]?.[1]}
                    name="isCounselorApproved"
                  />
                }
                label="Counselor approved"
              />
            )}
          </div>
        </div>
      </Stack>

      <Typography variant="subtitle2" sx={{ mt: '16px', color: 'text.secondary' }}>
        CONVERSATION
      </Typography>

      <Card sx={{ 
        backgroundColor: '#f8f9fa', 
        p: 2, 
        mb: 2, 
        // maxHeight: '300px', 
        // overflowY: 'auto',
        height: '300px', 
        overflow: 'auto',
        resize: 'vertical',
        
        border: '1px solid #e9ecef',
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#c1c1c1',
          borderRadius: '3px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#a8a8a8',
        },
      }} className="message-container">
        {notesData?.length === 0 && !isLoading && (
          <Typography 
            variant="body2" 
            color="textSecondary" 
            sx={{ 
              textAlign: 'center', 
              py: 3,
              fontStyle: 'italic',
              color: '#6c757d'
            }}
          >
            No messages yet. Start the conversation!
          </Typography>
        )}
        {isLoading && (
          <Typography 
            variant="body2" 
            color="textSecondary" 
            sx={{ 
              textAlign: 'center', 
              py: 3,
              color: '#6c757d'
            }}
          >
            Loading messages...
          </Typography>
        )}
        {notesData?.map((item: any, index) => (
          <div 
            key={index} 
            className="mb-3"
            style={{
              animation: item.message_id === newestMessageId ? 
                (item.from_id === personalStore.student_id ? 'slideInRight 0.4s ease-out' : 'slideInLeft 0.4s ease-out') : 
                'none'
            }}
          >
            <div 
              className="message-bubble"
              style={{
                backgroundColor: item.from_id === personalStore.student_id ? '#e3f2fd' : '#f3e5f5',
                borderRadius: '12px',
                padding: '12px 16px',
                marginBottom: '8px',
                border: `2px solid ${(item.message_id === newestMessageId) ? '#4caf50' : (item.from_id === personalStore.student_id ? '#bbdefb' : '#e1bee7')}`,
                position: 'relative',
                maxWidth: '85%',
                marginLeft: item.from_id === personalStore.student_id ? 'auto' : '0',
                marginRight: item.from_id === personalStore.student_id ? '0' : 'auto',
                boxShadow: (item.message_id === newestMessageId) ? '0 4px 12px rgba(76, 175, 80, 0.3)' : '0 1px 3px rgba(0,0,0,0.1)',
                transform: (item.message_id === newestMessageId) ? 'scale(1.02)' : 'scale(1)',
              }}
            >
              {(item.message_id === newestMessageId) && (
                <div 
                  className="new-message-label"
                  style={{
                    position: 'absolute',
                    top: '-8px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#4caf50',
                    color: 'white',
                    padding: '2px 8px',
                    borderRadius: '10px',
                    fontSize: '0.7rem',
                    fontWeight: 'bold',
                    zIndex: 1,
                  }}
                >
                  NEW
                </div>
              )}
              <Typography 
                variant="caption" 
                sx={{ 
                  color: '#666',
                  fontSize: '0.75rem',
                  display: 'block',
                  marginBottom: '4px',
                  fontWeight: '500'
                }}
              >
                {moment(item.created_at).format('MM/DD/YYYY - hh:mm A')}
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  lineHeight: '1.4',
                  wordBreak: 'break-word'
                }}
              >
                <span style={{ 
                  fontWeight: '600',
                  color: item.from_id === personalStore.student_id ? '#1976d2' : '#7b1fa2',
                  fontSize: '0.875rem'
                }}>
                  {item.creator ?? (item.from_id === personalStore.student_id ? 'You' : 'Counselor')}
                </span>
                <span
                  style={{ marginLeft: '8px' }}
                  dangerouslySetInnerHTML={{
                    __html: item.content.replace(/\n/g, ' <br> '),
                  }}
                />
              </Typography>
            </div>
          </div>
        ))}
      </Card>

      {/* Enhanced Message Input Area */}
      <Card sx={{ 
        backgroundColor: '#ffffff',
        border: '2px solid #e3f2fd',
        borderRadius: '16px',
        p: 2,
        mb: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        transition: 'all 0.3s ease',
        '&:hover': {
          borderColor: '#bbdefb',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        },
        '&:focus-within': {
          borderColor: '#1976d2',
          boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.1)',
        }
      }}>
        <div style={{ position: 'relative' }}>
          <textarea
            name="content"
            value={formik.values.content}
            onChange={handleTyping}
            placeholder="Type your message here..."
            style={{
              width: '100%',
              minHeight: '80px',
              padding: '12px 16px',
              border: 'none',
              borderRadius: '12px',
              fontSize: '14px',
              lineHeight: '1.5',
              resize: 'vertical',
              outline: 'none',
              fontFamily: 'inherit',
              backgroundColor: 'transparent',
            }}
          />
          <div style={{
            position: 'absolute',
            bottom: '8px',
            right: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            {isTyping && (
              <Typography 
                variant="caption" 
                sx={{ 
                  color: '#666',
                  fontStyle: 'italic',
                  fontSize: '0.75rem',
                  backgroundColor: '#f5f5f5',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  border: '1px solid #e0e0e0'
                }}
              >
                {typingUser} is typing...
              </Typography>
            )}
            <Button
              variant={!formik.values.content ? 'outline-secondary' : 'primary'}
              onClick={() => formik.handleSubmit()}
              disabled={!formik.values.content || isLoading}
              style={{
                minWidth: '80px',
                height: '32px',
                borderRadius: '16px',
                fontSize: '0.875rem',
                fontWeight: '600',
                textTransform: 'none',
                boxShadow: formik.values.content ? '0 2px 4px rgba(0,0,0,0.2)' : 'none',
                transition: 'all 0.2s ease',
                border: formik.values.content ? 'none' : '1px solid #dee2e6',
                backgroundColor: formik.values.content ? '#1976d2' : '#f8f9fa',
                color: formik.values.content ? '#ffffff' : '#6c757d',
              }}
              onMouseEnter={(e) => {
                if (formik.values.content) {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.3)';
                }
              }}
              onMouseLeave={(e) => {
                if (formik.values.content) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
                }
              }}
            >
              {isLoading ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <div style={{
                    width: '12px',
                    height: '12px',
                    border: '2px solid #ffffff',
                    borderTop: '2px solid transparent',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }} />
                  Sending...
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                  </svg>
                  Send
                </div>
              )}
            </Button>
          </div>
        </div>
      </Card>

      {error && (
        <Typography 
          variant="caption" 
          color="error" 
          sx={{ 
            mt: 1,
            display: 'block',
            padding: '8px 12px',
            backgroundColor: '#ffebee',
            borderRadius: '8px',
            border: '1px solid #ffcdd2',
            color: '#c62828'
          }}
        >
          {error}
        </Typography>
      )}
    </Card>
  );
};

export default ReviewPersonal;
